import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Check } from 'lucide-react';
import { Button } from '../../components/ui/button';

export default function ThankYou() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#f8fafc] flex items-center justify-center p-8">
      <div className="max-w-md w-full text-center">
        <div className="bg-white rounded-lg shadow-sm border border-[#e2e8f0] p-12">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-green-100 rounded-full mb-6">
            <Check className="w-10 h-10 text-green-600" />
          </div>
          <h1 className="text-3xl font-bold text-[#0f172a] mb-4" style={{ fontFamily: 'Outfit, sans-serif' }} data-testid="thank-you-heading">
            Thank You!
          </h1>
          <p className="text-[#475569] mb-8" style={{ fontFamily: 'Manrope, sans-serif' }} data-testid="client-profile-submitted-message">
            Your Client Profile has been submitted successfully. Your advisor will review your information and be in touch soon.
          </p>
          <div className="p-4 bg-[#f8fafc] rounded-md border border-[#e2e8f0] mb-8">
            <h2 className="text-lg font-bold text-[#0f172a] mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>
              <span style={{ fontWeight: 800 }}>STEELPEAK</span>{' '}
              <span style={{ fontWeight: 300 }}>WEALTH</span>
            </h2>
            <p className="text-sm text-[#475569]">Your trusted wealth management partner</p>
          </div>
        </div>
      </div>
    </div>
  );
}
